import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { QuarantineItem } from '@/pages/App/TestQuarantinePage/TestQuarantinePage.types';
import { monolithApi } from '@/utils/api';

export const testQuarantineItemPath = (projectSlug: string, testCaseId: string) => {
  return `/app/${projectSlug}/quarantine/test_case/${testCaseId}`;
};

const useTestQuarantineItem = <D = unknown>(
  projectSlug: string,
  method: 'patch' | 'delete',
  options: UseMutationOptions<AxiosResponse<D>, AxiosError, { id: string; payload?: QuarantineItem }>,
) => {
  return useMutation<AxiosResponse<D>, AxiosError, { id: string; payload?: QuarantineItem }>({
    mutationFn: ({ id, payload }) => monolithApi[method]<D>(testQuarantineItemPath(projectSlug, id), payload),
    ...options,
  });
};

export default useTestQuarantineItem;
